export default __webpack_public_path__ + "static/media/instagram.6bfaed33.svg";